// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pi-spin[data-v-0112e0d1] {\n  opacity: 0.65;\n  font-size: var(--0112e0d1-iconSize) !important;\n}\n.loading-container[data-v-0112e0d1] {\n  min-height: var(--0112e0d1-minHeight);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
